// extracted by mini-css-extract-plugin
export default {"container":"settings_container__v7qD6"};